import React from "react";

import { VenueErrorPage } from "./ErrorPage";

interface ErrorBoundaryProps {
  errorPage?: React.ReactNode;
  render?: (message: string, resetState: () => void) => React.ReactNode;
  children: React.ReactNode;
}
class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  { hasError: boolean; errorMessage: string }
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, errorMessage: "" };
  }

  static getDerivedStateFromError(error: Error) {
    console.log("getDerivedStateFromError", { error });
    // Update state so the next render will show the fallback UI.
    return { hasError: true, errorMessage: error.message };
  }

  render() {
    const { errorPage } = this.props;
    const resetError = () => this.setState({ ...this.state, hasError: false });
    console.log("Error boundry", this.state.errorMessage);
    if (this.state.hasError) {
      if (this.props.render) {
        console.log("Error boundry render props");
        console.log("Error boundry", this.state.errorMessage);
        return this.props.render(this.state.errorMessage, resetError);
      }
      console.log("Error boundry", this.state.errorMessage);
      return (
        errorPage || (
          <div>
            <VenueErrorPage resetError={resetError} />
          </div>
        )
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
